// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3nei7","subtitle":"styles_subtitle__1Bk_M","encerrar":"styles_encerrar__2BJQB","ativar":"styles_ativar__3mcI9","salvar":"styles_salvar__3scg3"};